const ibs_questions = [
  {
    question: "How is ##name## being evaluated today?",
    sub: "",
    type: "radio",
    telehealth: "F[0].Page_1[0].HowExamCOnducted[0]",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    questions: [
      {
        label: "How was the examination conducted?",
        title: "",
        subMain: "",
        sub: "",
        radioGroup: "F[0].Page_1[0].RadioButtonList[3]",
        options: [
          {
            main: "In-Person Exam",
            dbqName: "1",
            sub: "",
          },
          {
            main: "Video Telehealth",
            dbqName: "2",
            sub: "",
          },
        ],
        answer: "In-Person Exam",
      },
    ],
  },
  {
    question: "Is ##name## regularly seen as a patient in your clinic?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    presidence: "Yes",
    radioGroup: "F[0].Page_1[0].RadioButtonList[2]",
    ref: 0,
    dbqName_yes: "1",
    dbqName_no: "2",
    answer: "",
  },
  {
    question: "Did you review any of the patients records for this condition?",
    sub: "Please identify the evidence reviewed and the date range",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    presidence: "Yes",
    maxLength: 4000,
    radioGroup: "F[0].Page_1[0].RadioButtonList[0]",
    ref: 0,
    dbqName_yes: "2",
    dbqName_no: "1",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please identify the evidence reviewed and the date range",
    textdbqName: "F[0].Page_1[0].IdentifyEvidence[0]",
    textanswer: "",
  },
  {
    question:
      "Does ##name## have any signs or symptoms attributable to any non-surgical non-infectious intestinal conditions(s)?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "SIGNS AND SYMPTOMS",
      number: "3",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].#subform[2].Yes3[0]",
    dbqName_no: "F[0].#subform[2].No3[0]",
    answer: "",
  },
  {
    question:
      "Signs or symptoms attributable to any non-surgical non-infectious intestinal conditions(s)",
    sub: "check all that apply",
    type: "radioTiles",
    multi: true,
    textarea: true,
    show: false,
    section: {
      page: "3",
      title: "SIGNS AND SYMPTOMS",
      number: "3",
    },
    refId: 1,
    cols: 2,
    questions: [
      {
        main: "Diarrhea",
        dbqName: "F[0].#subform[2].Signs3a1[0]",
        answer: "",
        maxLength: 80,
        textdbqName: "F[0].#subform[2].DescribeOther31[0]",
        placeholder: "Describe the Symptoms",
        textAnswer: "",
      },
      {
        main: "Alternating diarrhea and constipation",
        dbqName: "F[0].#subform[2].Signs3a2[0]",
        answer: "",
        maxLength: 80,
        textdbqName: "F[0].#subform[2].DescribeOther32[0]",
        placeholder: "Describe the Symptoms",
        textAnswer: "",
      },
      {
        main: "Abdominal distension",
        dbqName: "F[0].#subform[2].Signs3a3[0]",
        answer: "",
        maxLength: 80,
        textdbqName: "F[0].#subform[2].DescribeOther33[0]",
        placeholder: "Describe the Symptoms",
        textAnswer: "",
      },
      {
        main: "Nausea",
        dbqName: "F[0].#subform[2].Signs3a5[0]",
        answer: "",
        maxLength: 80,
        textdbqName: "F[0].#subform[2].DescribeOther34[0]",
        placeholder: "Describe the Symptoms",
        textAnswer: "",
      },
      {
        main: "Vomiting",
        dbqName: "F[0].#subform[2].Signs3a6[0]",
        answer: "",
        maxLength: 80,
        textdbqName: "F[0].#subform[2].DescribeOther35[0]",
        placeholder: "Describe the Symptoms",
        textAnswer: "",
      },
      {
        main: "Other",
        dbqName: "F[0].#subform[2].Signs3a7[0]",
        answer: "",
        maxLength: 80,
        textdbqName: "F[0].#subform[2].DescribeOther36[0]",
        placeholder: "Describe the Symptoms",
        textAnswer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Does ##name## have episodes of bowel disturbance with abdominal distress, or exacerbations or attacks of the intestinal condition?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "SYMPTOM EPISODES, ATTACKS AND EXACERBATIONS",
      number: "4",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].#subform[2].Yes4[0]",
    dbqName_no: "F[0].#subform[2].No4[0]",
    answer: "",
  },
  {
    question:
      "Indicate the severity and frequency of the distress, or exacerbations or attacks",
    sub: "",
    type: "checkbox",
    multi: true,
    small: true,
    show: false,
    refId: 1,
    cols: 2,
    section: {
      page: "3",
      title: "SYMPTOM EPISODES, ATTACKS AND EXACERBATIONS",
      number: "4",
    },
    questions: [
      {
        main: "Episodes of bowel disturbance with abdominal distress",
        dbqName: "F[0].#subform[2].FREQUENCY4[0]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Occasional episodes",
            dbqName: "F[0].#subform[2].Occasional1[0]",
            answer: "",
          },
          {
            main: "Frequent episodes",
            dbqName: "F[0].#subform[2].Occasional1[1]",
            answer: "",
          },
          {
            main: "More or less constant abdominal distress",
            dbqName: "F[0].#subform[2].Occasional1[2]",
            answer: "",
          },
        ],
      },
      {
        main: "Indicate the numbers of episodes of exacerbations and/or attacks of the intestinal condition",
        dbqName: "F[0].#subform[2].Episodes4[0]",
        answer: "",
        text1: "",
        placeholder1: "Describe typical exacerbation or attack",
        dbqName1: "F[0].#subform[2].DescribeOther4ab[0]",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "0 episode",
            dbqName: "F[0].#subform[2].Numbers4ab[2]",
            answer: "",
          },
          {
            main: "1 episode",
            dbqName: "F[0].#subform[2].Numbers4ab[3]",
            answer: "",
          },
          {
            main: "2 episodes",
            dbqName: "F[0].#subform[2].Numbers4ab[4]",
            answer: "",
          },
          {
            main: "3 episodes",
            dbqName: "F[0].#subform[2].Numbers4ab[5]",
            answer: "",
          },
          {
            main: "4 episodes",
            dbqName: "F[0].#subform[2].Numbers4ab[6]",
            answer: "",
          },
          {
            main: "5 episodes",
            dbqName: "F[0].#subform[2].Numbers4ab[0]",
            answer: "",
          },
          {
            main: "6 episodes",
            dbqName: "F[0].#subform[2].Numbers4ab[7]",
            answer: "",
          },
          {
            main: "7 or more episodes",
            dbqName: "F[0].#subform[2].Numbers4ab[1]",
            answer: "",
          },
        ],
      },
    ],
    answer: "",
  },
  // {
  //    "question":"Indicate Frequency of Episodes",
  //    "sub":"",
  //    "type":"radioTiles",
  //    "multi": false,
  //    "small": true,
  //    "show": false,
  //    "refId":1,
  //    "cols": 2,
  //    "questions":[
  //       {
  //          "main":"Occasional episodes",
  //          "dbqName":"F[0].#subform[2].Occasional1[0]",
  //          "answer":""
  //       },
  //       {
  //          "main":"Frequency of Episodes",
  //          "dbqName":"F[0].#subform[2].Occasional1[1]",
  //          "answer":""
  //       },
  //       {
  //          "main":"More or less constant abdominal distress",
  //          "dbqName":"F[0].#subform[2].Occasional1[2]",
  //          "answer":""
  //       }
  //    ],
  //    "answer":""
  // },
  {
    question: "Additional Comments",
    sub: "",
    optional: true,
    type: "textarea",
    maxLength: 2130,
    show: true,
    section: {
      page: "6",
      title: "REMARKS",
      number: "11",
    },
    dbqName: "F[0].Page_4[0].REMARKSIfany[0]",
    answer: "",
  },
];

export default ibs_questions;
